import React from "react";

function Navbar(){
    return (
      <div>
<nav className="navbar navbar-expand-lg navbar-dark bg-transparent ">
<div className="container-fluid">
  <a className="navbar-brand" href="#">Bolt Librarian</a>
  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>
  <div className="collapse navbar-collapse" id="navbarNav">
    <ul className="navbar-nav ms-auto">
      <li className="nav-item">
        <a className="nav-link" aria-current="page" href="/">Home</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/about">About</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/contact">Contact</a>
      </li>

    </ul>
  </div>
</div>
</nav>
      </div>
    )
}

export default Navbar;